<template>
	<div class="form-group">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<input type="number" :name="name" :id="name" :step="step" v-model="model" v-validate="rules" :data-vv-as="placeholder" :placeholder="placeholder" class="form-control" :class="{ error: errors.has(name) }">
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'step',
		'name',
		'placeholder',
		'rules'
	],
	computed: {
		model: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputFloat.vue